function open(vm) {
  return vm.$buefy.loading.open({ container: null });
}

export default {
  open,
};
